const e={default:"default",error:"error",success:"success",warning:"warning"},a=s=>s?!!e[s]:!1,i={default:e.default,error:e.error,success:e.success,warning:e.warning};export{a as isMessageType,e as themes,i as types};
//# sourceMappingURL=message.types.js.map
